import { Alert } from 'deda-rkit';
import * as React from 'react';
import { isType } from '../mixin/functions';
import parse from "html-react-parser";
import DOMPurify from "dompurify";

/*
Prende il valore del flash e visualizza gli alert col colore bootstrap seguendo la convenzione

flash{'successMsg': "Hai inserito i dati correttamente!", -> alert di tipo success
      'dangerMsg': "Mancano dati obbligatori!",   -> alert di tipo danger
      'infoMsg': "Mancano dati obbligatori!",   -> alert di tipo info
      'warningMsg': "Mancano dati obbligatori!",   -> alert di tipo warning
'}

*/

type FlashProps = {
    flash: any;
}

export default class FlashAlert extends React.Component<FlashProps> {
    
    constructor(props: FlashProps) {
        super(props);
    }

    render(){

        const par_parse = {
            USE_PROFILES: { html: true },}
        return (
            <>
                {   this.props.flash != null && Object.keys(this.props.flash).map((tipoMessaggio, index) => {
                        /* mostro solo gli alert con chiave di bootstrap */
                        if(['dangerMsg','warningMsg','successMsg','infoMsg'].includes(tipoMessaggio)){ 
                            return (
                                <>
                                    
                                    { isType(this.props.flash[tipoMessaggio],'array') && this.props.flash[tipoMessaggio].map((messaggio, i) => (
                                            <Alert key={"alert_"+tipoMessaggio.toString().replace('Msg','')+i} color={tipoMessaggio.toString().replace('Msg','')}>
                                                {parse(DOMPurify.sanitize(messaggio,par_parse ))}
                                            </Alert>
                                        ))
                                    }
                                    { isType(this.props.flash[tipoMessaggio],'string') && (
                                            <Alert key={tipoMessaggio.toString().replace('Msg','')} color={tipoMessaggio.toString().replace('Msg','')}>
                                                {parse(DOMPurify.sanitize(this.props.flash[tipoMessaggio],par_parse ))}
                                            </Alert>
                                        )
                                    }
                                
                                </>
                            )
                        }
                        
                    })
                }
            </>              
        );
    };
}